export default __webpack_public_path__ + "static/ab-laptop-2-003cb7f4a6e953303aab85cab3801397.jpg";